module.exports = __webpack_public_path__ + "img/暂停.d7d0bb4f.png";